import { setTokenHeader } from "../axios";
export const DISALLOWED_REDIRECTS = [
  "login",
  "reset",
  "forgot",
  "sign-up",
  "user-info",
  "verify-email",
  "registration-complete",
  "denied",
  "account-deleted",
];
export const SESSION_EXPIRED = "expired";
export const ACCESS_DENIED = "AccessDenied";
export const JWT_TOKEN = "jwtToken";
export const REDIRECT_KEY = "redirect";

export function setAuthorizationToken(token) {
  setTokenHeader(token);
}

export const setLoggedInState = (jwt) => {
  localStorage.setItem(JWT_TOKEN, jwt);
  setAuthorizationToken(jwt);
};

export const clearUserState = () => {
  localStorage.clear();
  setAuthorizationToken(false);
};
